import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from 'src/app/shared/shared.module';
import { AudienceListComponent } from './audience-list/audience-list.component';
import { SelectAudienceCustomFieldsToExportComponent } from './shared/select-audience-custom-fields-to-export/select-audience-custom-fields-to-export.component';
import { DialogContainerForAjsComponent } from '../mass-messaging/creation-edition-dialog/dialog-container-for-ajs/dialog-container-for-ajs.component';

@NgModule({
  declarations: [AudienceListComponent, DialogContainerForAjsComponent, SelectAudienceCustomFieldsToExportComponent],
  imports: [CommonModule, SharedModule],
})
export class AudienceModule {}
